export default "__VITE_ASSET__nRyzTGcL__"